import {
  type ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@shared-components/shadcn/chart";
import { Bar, CartesianGrid, XAxis, YAxis, Legend, BarChart } from "recharts";
import { api } from "@shared-server/api";
import type { GranularityType } from "@shared-server/api/routers/queries/metrics/utils";

type ProfilesContentProps = {
  startDate: Date;
  endDate: Date;
  granularity: GranularityType;
};

const chartConfig: ChartConfig = {
  count: {
    label: "Profiels content",
  },
};

export const ProfilesContent = (props: ProfilesContentProps) => {
  const { data } = api.coreMetrics.profilesContent.useQuery({
    dateStart: props.startDate,
    dateEnd: props.endDate,
    granularity: props.granularity,
  });

  const chartData = data || [];

  return (
    <div>
      <h2 className="mb-4">{chartConfig.count?.label}</h2>
      <ChartContainer
        config={chartConfig}
        className="aspect-auto h-[150px] w-full"
      >
        <BarChart accessibilityLayer data={chartData}>
          <CartesianGrid vertical={false} />
          <XAxis
            dataKey="date"
            xAxisId={"date"}
            tickLine={false}
            axisLine={false}
            tickMargin={8}
          />
          <YAxis
            interval={1}
            tickLine={false}
            axisLine={false}
            orientation="left"
            allowDecimals={false}
          />
          <ChartTooltip
            content={
              <ChartTooltipContent
                className="w-[150px]"
                nameKey="date"
                labelFormatter={(value: string) => {
                  return value;
                }}
              />
            }
          />
          <Legend />
          <Bar
            yAxisId={0}
            xAxisId="date"
            dataKey="hasAttachedContextFiles"
            className="fill-ter-blue-500"
            fill="#006e96"
            name="Attached Context Files Count"
          />
          <Bar
            yAxisId={0}
            xAxisId="date"
            dataKey="hasEnabledTools"
            className="fill-ter-yellow-600"
            fill="#eaaa00"
            name="Enabled Tools Count"
          />
          <Bar
            yAxisId={0}
            xAxisId="date"
            dataKey="profilesCreated"
            className="fill-ter-mint-500"
            fill="#53b692"
            name="Profiles Created"
          />
        </BarChart>
      </ChartContainer>
    </div>
  );
};
